{
  "meta-title": "Settings",

  "nav-link-account": "My Account",
  "nav-link-firms": "Firm Settings",

  "software-token-mfa-btn-title": "2-Step Verification",
  "software-token-mfa-authenticate-forgot-password": "Forgot your password?",
  "software-token-mfa-btn-body": "An additional layer of security for your account when you login.",
  "software-token-mfa-verify-prompt": "First, let's verify your identity.",
  "software-token-mfa-scan-app-prompt": "Great! Now scan the code with your authenticator app.",
  "software-token-mfa-pick-friendly-device-name-option-title": "Choose your authenticator app",
  "software-token-mfa-enter-code-title": "Enter Code",
  "software-token-mfa-enter-code-desc": "Enter the one-time code from your authenticator app to finish setup.",
  "software-token-mfa-enter-code-btn": "Verify Code",
  "software-token-mfa-success-title": "Success!",
  "software-token-mfa-success-body": "You’ve finished setting up 2-step verification. Next time you sign in to Elements, you’ll use your authenticator app to verify your identity.",
  "software-token-mfa-success-btn": "Got it",
  "software-token-mfa-disable-prompt": "Enter the code from authenticator.",

  "change-email-label": "Enter your new email address",
  "change-email-btn": "Verify Email Address",
  "change-email-heading-1": "Almost there",
  "change-email-heading-2": "Check your inbox and confirm your new email address.",
  "change-email-body-1": "Just click the \"Confirm Email Address\" button in the email we've just sent to",
  "change-email-body-2": "If you've received multiple verification emails, please use the newest verification link.",
  "change-email-body-3": "Failure to verify your email address will result in being unable to sign in to Elements.",
  "change-email-footer": "Didn't receive the verification email?",
  "change-email-footer-link": "Resend Verification Email",
  "change-email-verified-title": "Thanks for verifying your new email",
  "change-email-unverified-title": "Error - verification unsuccessful",
  "change-email-verified-body": "Now that your new email address has been verified, you can use it to log into your Elements account.",
  "change-email-unverified-body": "Please try again. If you've received multiple verification emails, please use the newest verification link.",
  "change-email-resend-verification-notification": "Verification email resent to {{email}}",
  "change-email-unverified-email-tooltip": "Unverified email address. Click to resend verification.",

  "err-generic": "Oops, something went wrong. Please try again.",
  "err-invalid-email": "Invalid email.",
  "err-invalid-password": "Invalid password.",
  "err-invalid-device-friendly-name": "Invalid authenticator app.",
  "err-additional-auth-challenges": "Unable to complete request, please sign out and sign in, then try again.",
  "err-invalid-totp-code": "Incorrect code. Please double-check your verification code and try again.",
  "err-invalid-credentials": "The Email or Password you entered was incorrect. Please try again.",

  "update-password-btn": "Update Password",

  "calendar-scheduling-link-section-header": "Calendar Scheduling Link",
  "calendar-scheduling-link-section-body": "Add a link from your calendaring service to help your clients schedule time with you."
}
